import { trackEvent, identifyUser, setUserProperties, resetMixpanel, trackPageView } from 'services/mixpanel'

/**
 * Hook to use Mixpanel analytics in React components
 *
 * @example
 * ```tsx
 * const { track, identify, setProperties } = useMixpanel()
 *
 * track('Button Clicked', { button_name: 'Sign Up' })
 * identify('user-123', { email: 'user@example.com' })
 * setProperties({ plan: 'premium' })
 * ```
 */
export const useMixpanel = () => {
	return {
		track: trackEvent,
		identify: identifyUser,
		setProperties: setUserProperties,
		reset: resetMixpanel,
		trackPageView,
	}
}

export default useMixpanel
